<template>
  <div>

    <div class="w-100" v-if="isActivatedGame" style="text-align: center">
      <apexchart v-if="!noData" :height="height" type="bar" :options="chartOptions" :series="series"></apexchart>
      <span v-else>{{ $t(`texts.data.no-campaigns-purchased`) + ' ' + $t(`texts.data.no-data-purchased`) }}</span>
    </div>
    <div v-else style="text-align: center">
      <div class="w-100">
        <span style="text-align: center">Unfortunately this chart is available only in active game mode.</span>
      </div>
    </div>
  </div>
</template>

<script>

import {mapGetters} from "vuex";

export default {
  name: "CampaignsVsDataChart",
  data: () => ({
    noData: false,
    series: [],
    chartOptions: {
      chart: {
        type: 'bar',
        stacked: false, // zatím knihovna neumí stacked a gruped v 1
        toolbar: {
          show: true
        }
      },
      responsive: [{
        breakpoint: 480,
        options: {
          legend: {
            position: 'bottom',
            offsetX: -10,
            offsetY: 0
          }
        }
      }],
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '55%',
        },
      },
      yaxis: {
        title: {
          text: "Money"
        }
      },
      xaxis: {
        categories: [],
        title: {
          text: "Team name"
        }
      },
      legend: {
        position: 'right',
        offsetY: 40
      },
      fill: {
        opacity: 1
      }
    },
  }),
  computed: {
    ...mapGetters(['teamsData', 'allGameCampaigns', 'gameAllTeams', 'myOwnedActivateGames']),
    //protože se data neukládají po skončení hry
    isActivatedGame() {
      return this.myOwnedActivateGames.length;
    }
  },
  props: {
    selectedRound: Number,
    height: Number
  },
  watch: {
    selectedRound: function () {
      this.reset();
      this.createChart();
      this.setTitle();
    },
    teamsData: function () {
      this.reset();
      this.createChart();
    },
    allGameCampaigns: function () {
      this.reset();
      this.createChart();
    }
  },
  created() {
    this.createChart();
    this.setTitle();
  },
  methods: {
    reset: function () {
      this.series = [];
      this.chartOptions.labels = [];
      this.chartOptions.title.text = ``;
      this.chartOptions.xaxis.categories = [];
    },
    async createChart() {
      let allTeamsData = this.teamsData;
      let allTeams = this.gameAllTeams;
      let allCampaigns = this.allGameCampaigns;

      if ((!allTeamsData || !allTeamsData.length > 0) && (!allCampaigns || !allCampaigns.length > 0)) {
        this.noData = true;
        return false;
      }

      allTeams.forEach(t => this.chartOptions.xaxis.categories.push(t.name))
      //DATA
      if (allTeamsData && allTeamsData.length > 0) {
        this.series.push({
          name: "Data costs",
          data: this.createChartData(allTeams, allTeamsData)
        });
      }
      //CAMPAIGNS
      if (allCampaigns && allCampaigns.length > 0) {
        this.series.push({
          name: "Campaigns costs",
          data: this.createChartData(allTeams, allCampaigns)
        });
      }
    },
    createChartData: function (sortedTeams, allTeamsData) {
      let data = [];
      sortedTeams.forEach(t => {
        let spent = 0;
        let filtered = allTeamsData.find(oneTeam => oneTeam.id === t.id);
        filtered.results.forEach(r => {
          if (r.turn === this.selectedRound) {
            spent += r.price;
          }
        });
        data.push(spent);
      })
      return data;
    },
    setTitle() {
      this.chartOptions = {
        ...this.chartOptions, title: {
          text: `Money spent on campaigns and data in round ${this.selectedRound}`
        }
      }
    }
  }
};
</script>
